module.exports = __webpack_public_path__ + "users-group.41c89f880263037ac64dea363bb038ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/users-group.svg
// module id = 1152
// module chunks = 0